import { render } from "./create-estimate.vue?vue&type=template&id=23230b87"
import script from "./create-estimate.vue?vue&type=script&lang=js"
export * from "./create-estimate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__